/*
 * Error Page Messages
 *
 * This contains all the text for the ErrorPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.components.ErrorPage';

export default defineMessages({
  unauthorizedTitle: {
    id: `${scope}.unauthorizedTitle`,
    defaultMessage: 'You need permission',
  },
  unauthorizedDescription: {
    id: `${scope}.unauthorizedDescription`,
    defaultMessage: 'Contact the project owner to request access to this content.',
  },
});
